import { render, staticRenderFns } from "./AppLoggedInLayout.vue?vue&type=template&id=3dc56f40&scoped=true&"
import script from "./AppLoggedInLayout.vue?vue&type=script&lang=js&"
export * from "./AppLoggedInLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppLoggedInLayout.vue?vue&type=style&index=0&id=3dc56f40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc56f40",
  null
  
)

export default component.exports